import { Component, HostListener, ViewChild } from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';

import { NavigationEnd, Router } from '@angular/router';

import { EasyDebugDecorator } from '@app/decorators/easy-debug.decorator';

import { ModalIframeComponent, ModalMarketingComponent } from '@app/modals';

import { CancelAsync, Serie, Session, Student, StudentPurshasesDetails } from '@app/models';

import {
  AppInitService,
  AppRatingService,
  CDRLessonsService,
  CdrVersionService,
  CerfaService,
  ConfigService,
  ConfigUserService,
  CPFSubscriptionsService,
  ExamenCodeService,
  GamificationService,
  NavigationService,
  NetworkStatusService,
  PageLoaderService,
  SeriesService,
  SessionsService,
  StatsService,
  StorageService,
  StudentDocumentsService,
  StudentService,
  UserErrorHandlerService,
} from '@app/services';

import { Adjust } from '@awesome-cordova-plugins/adjust/ngx';

import { GroupByPipe } from '@commons/pipes/groupBy';

import { PricesFormater } from '@commons/pipes/prices.pipe';

import { ToasterCustomService, ToasterService, UtilsService } from '@commons/services';

import { ModalController, Platform } from '@ionic/angular';
import * as moment from 'moment-timezone';

@EasyDebugDecorator
@Component({
  selector: 'code-home-page',
  templateUrl: 'code-home.page.html',
  styleUrls: ['code-home.page.scss'],
})
export class CodeHomePage extends CancelAsync {

  @ViewChild('modalNoErrors') modalNoErrors: any;
  @ViewChild('modalSeriesFailed') modalSeriesFailed: any;
  @ViewChild('modalDailyStreak') modalDailyStreak: any;
  @ViewChild('modalNEPHInfos') modalNEPHInfos: any;
  @ViewChild('modalANTSInfos') modalANTSInfos: any;

  lockedFeatures = ['series/', 'statistiques'];

  pageTitle = 'Code';
  activeLink = 'code';

  iconPath = './uikit-assets/icons/orion-svg-sprite.svg#';

  initServiceDone = false;

  isDesktop = (window.innerWidth > 767) ? true : false;
  isMaxMobile = (window.innerWidth > 430) ? true : false;
  isCordova = false;

  blocHeaderTitle = 'Code de la route';

  pricesFormater = new PricesFormater();

  showSpiner = false;

  student: Student;
  userLifeCycle: any;
  configUser: any;
  configApp: any;

  showIOSATTScreen = false;

  groupByPipe = new GroupByPipe();
  coursGroupByValue = 'rank';
  subCoursGroupByValue = 'lessonName';
  coursList: any;
  coursProgression = [];
  iconIndexFromLastCours = null;
  index = null;
  percent = null;
  showLastCours = false;

  groupList = ['Entraînements au code', 'Révisions du code', 'Examen du code'];

  returningUserCase = false;

  cardsList: any = [
    // COMBO : logged: FALSE + engaged: FALSE veut dire que c'est dispo dès guest
    // COMBO : logged: FALSE + engaged: TRUE veut dire que c'est dispo que si t'es engaged, pas si t'es logged
    // COMBO : logged: TRUE + engaged: TRUE veut dire que c'est dispo dès logged
    { group: 'Entraînements au code', title: 'Séries simples', link: 'series/entrainements', possibleLink: 'series/entrainements', icon: 'serie-simple', logged: false, engaged: false, code: false, locked: true },
    { group: 'Entraînements au code', title: 'Examens blancs', link: 'series/examens', possibleLink: 'series/examens', icon: 'examen-blanc', logged: true, engaged: true, code: false, locked: true },
    { group: 'Entraînements au code', title: 'Séries thématiques', link: 'series/thematiques', possibleLink: 'series/thematiques', icon: 'thematiques', logged: false, engaged: true, code: true, locked: true},
    { group: 'Entraînements au code', title: 'Révise ton code avec nous sur Tiktok', link: 'tiktok', possibleLink: 'tiktok', icon: 'video-default', logged: false, engaged: false, code: false, locked: false},
    { group: 'Entraînements au code', title: 'Mes erreurs', link: 'series/erreurs/buffer', possibleLink: 'series/erreurs/buffer', icon: 'erreurs', logged: false, engaged: true, code: true, locked: true},
    { group: 'Entraînements au code', title: 'Statistiques', link: 'statistiques', possibleLink: 'statistiques', icon: 'statistiques', logged: false, engaged: false, code: false, locked: true },
    // { group: 'Révisions du code', title: 'Commander mon livret de code', link: 'livret', possibleLink: 'synced-book', icon: 'livret-de-code', logged: false, engaged: false, code: false, locked: true },
    { group: 'Révisions du code', title: 'Cours de code', link: 'cours', possibleLink: 'cours', icon: 'cours', logged: false, engaged: false, code: false, locked: true },
    { group: 'Révisions du code', title: 'Recevoir le livre de code', link: 'livret', possibleLink: 'livret', icon: 'code', logged: false, engaged: false, code: false, locked: true },
    { group: 'Révisions du code', title: 'Fiches récap', link: 'fiches-recap', possibleLink: 'fiches-recap', icon: 'fiches', logged: false, engaged: false, code: false, locked: true },
    { group: 'Révisions du code', title: 'Nos replays de live de code', link: 'youtubeTiktok', possibleLink: 'youtubeTiktok', icon: 'video-default', logged: false, engaged: false, code: false, locked: true },
    { group: 'Examen du code', title: 'Terminer mon inscription', link: 'terminer-mon-inscription', possibleLink: 'terminer-mon-inscription', icon: 'resultat', logged: false, engaged: false, code: false, locked: true },
    { group: 'Examen du code', title: 'Passer l’examen plus vite', link: 'insExamen', possibleLink: 'insExamen', icon: 'speed', logged: false, engaged: false, code: false, locked: true },
  ];
  cardsListDone = false;

  cerfaStatus = null;
  loadStudentCerfaFailed = false;
  noCerfa = true;
  isCerfaValid = false;
  cerfaDone = false;
  CPFSubscriptionsToConfirm = [];

  longLoading = false;
  pageStart = Date.now();
  checkPageLoadingTimeInterval: any;

  seriesList: Array<Serie> = [];
  seriesListFailed = false;
  getSerieFailed = false;
  sessions: Array<Session> = [];
  getSessionsFailed = false;
  utilsSeries: any[] = [];
  nbErreurs = 0;
  nbErrorsDone = false;

  // PAYMENTS GIFTS OFFERS
  studentPurshases: StudentPurshasesDetails;
  payments = [];
  gifts = [];
  coupons = [];
  paymentsGiftsCoupons: any = [];
  offers: any = [];
  fetchOffersFailed = false;
  studentCustomOffers: any = [];
  fetchStudentCustomOffersFailed = false;
  isPackPermis = false;
  isPackCode = false;
  isPackCodePremium = false;
  isHourOnly = false;
  hasHours = false;
  paymentsDone = false;
  giftsWithHours = false;

  examReservationWaitingCredits = false;
  missingCredits = 0;

  CPFStartingSoon = [];
  CPFInEDOFErrorStatus = [];

  examenCode: any;
  examenCodeDone = false;
  fetchExamenCodeByUserIdFailed = false;

  displayModalPostRegistration = false;
  displayModalObjectifCode = false;
  displayModalHasAutoEcole = false;
  displayModalHasNotAutoEcole = false;
  displayModalDossierExam1 = false;
  displayModalDossierExam2 = false;
  displayModalNoErrors = false;
  displayModalSeriesFailed = false;
  displayModalCPFSubscription = false;
  displayModalDailyStreak = false;
  displayModalNEPHInfos = false;
  displayModalANTSInfos = false;

  showEmbedElt = false;
  embedSrc = null;
  embedSrcANTS = null;

  isEngaged = false;

  hasPromoCard = false;
  promoCardTemplate = null;
  promoDates = [
    {
      start_at: '2020/12/16 00:00:00',
      end_at: '2020/12/28 23:59:59',
      template: 'default',
      forceDemo: false,
    },
    {
      start_at: '2021/01/12 00:00:00',
      end_at: '2021/02/05 23:59:59',
      template: 'happygift',
      forceDemo: false,
    },
    {
      start_at: '2021/02/22 00:00:00',
      end_at: '2021/03/10 23:59:59',
      template: 'happygift',
      forceDemo: false,
    },
  ];

  // customRadioOptions = [
  //   {value: 'week', text: 'Semaine'},
  //   {value: 'month', text: 'Mois'},
  //   {value: 'total', text: 'Total'},
  // ];

  pubInAppGuestCard = {
    card: {
      cardName: 'series-big-cards2',
      cardType: 'big',
      code: true,
    },
    cta: '',
    icon: '',
    link: 'modalSeriesGuest',
    sstext: '',
    text: 'Crée gratuitement ton compte pour accéder à de nouveaux modes d’entraînement',
    title: '',
  };

  pubInAppRegisteredCard = {
    card: {
      cardName: 'series-big-cards2',
      cardType: 'big',
      code: true,
    },
    cta: '',
    icon: '',
    link: 'permis',
    sstext: '',
    text: 'Pack Permis : la formation code + permis où l’on te chouchoute.',
    title: '',
  };

  callCenterPhone = '0800 0200 0200';
  callCenterPhoneFormatted = '080002000200';

  dailyStreakLoading = true;
  dailyStreakDegradedText;
  currentDailyStreakText;
  maxDailyStreakText;
  dailyStreakDays = [];
  days = ['lun', 'mar', 'mer', 'jeu', 'ven', 'sam', 'dim'];

  stepChangeSub: any;
  pageLoaderSteps = [
    'init0',
    'init1',
    'init2',
    'init3',
    'init4',
    'init5',
    'initPage',
  ];
  hasMadeInit = false;

  navigationSubscription: any;

  addEntriesForDebug = false;

  // POST REGISTRATION
  insAutoEcole = null;
  objectifCode = null;
  redirectCustom = null;

  fromLogin = false;
  fromSignup = false;

  startTime = Date.now();

  initFullDone = false;
  statsSent = false;
  packPermisPrice = '749€';
  packPermisHours = '17h';
  minHourPrice = '37€/h';
  showModalConsentPush = false;

  displayMajCode2023 = false;
  displayRestartCode2023 = false;
  displayErrorCode2023 = false;
  majModalDisplayed = false;
  displayNEPHInfosCard = false;

  private hasInitializedDailyStreak = false;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.isDesktop = (window.innerWidth > 767) ? true : false;
    this.isMaxMobile = (window.innerWidth > 430) ? true : false;
  }

  constructor(
    private appInitService: AppInitService,
    private pageLoaderService: PageLoaderService,
    private studentService: StudentService,
    private navigationService: NavigationService,
    public platform: Platform,
    private modalController: ModalController,
    private cerfaService: CerfaService,
    private examenCodeService: ExamenCodeService,
    private statsService: StatsService,
    public router: Router,
    public utils: UtilsService,
    private seriesService: SeriesService,
    private sessionsService: SessionsService,
    private appRatingService: AppRatingService,
    public toasterService: ToasterService,
    public toasterCustomService: ToasterCustomService,
    public cdrLessonsService: CDRLessonsService,
    private configUserService: ConfigUserService,
    private configService: ConfigService,
    private storageService: StorageService,
    public gamificationService: GamificationService,
    private adjust: Adjust,
    public sanitizer: DomSanitizer,
    public networkStatusService: NetworkStatusService,
    public userErrorHandlerService: UserErrorHandlerService,
    public CPFSubscriptionsService: CPFSubscriptionsService,
    private cdrVersionService: CdrVersionService,
    public studentDocumentsService: StudentDocumentsService,
  ) {
    super({ cancel: false, subscription: null });

    // -- GAMIFICATION --
    this.groupList = ['Entraînements au code', 'Révisions du code', 'Examen du code'];

    this.cardsList = [
      // COMBO : logged: FALSE + engaged: FALSE veut dire que c'est dispo dès guest
      // COMBO : logged: FALSE + engaged: TRUE veut dire que c'est dispo que si t'es engaged, pas si t'es logged
      // COMBO : logged: TRUE + engaged: TRUE veut dire que c'est dispo dès logged
      { group: 'Entraînements au code', title: 'Jours d’affilée', link: 'daily-streak', possibleLink: 'daily-streak', icon: '', logged: false, engaged: false, code: false, locked: true },
      { group: 'Entraînements au code', title: 'Séries simples', link: 'series/entrainements', possibleLink: 'series/entrainements', icon: 'serie-simple', logged: false, engaged: false, code: false, locked: true },
      { group: 'Entraînements au code', title: 'Examens blancs', link: 'series/examens', possibleLink: 'series/examens', icon: 'examen-blanc', logged: true, engaged: true, code: false, locked: true },
      { group: 'Entraînements au code', title: 'Révise ton code avec nous sur Tiktok', link: 'tiktok', possibleLink: 'tiktok', icon: 'video-default', logged: false, engaged: false, code: false, locked: false},
      { group: 'Entraînements au code', title: 'Séries thématiques', link: 'series/thematiques', possibleLink: 'series/thematiques', icon: 'thematiques', logged: false, engaged: true, code: true, locked: true},
      { group: 'Entraînements au code', title: 'Mes erreurs', link: 'series/erreurs/buffer', possibleLink: 'series/erreurs/buffer', icon: 'erreurs', logged: false, engaged: true, code: true, locked: true},
      { group: 'Entraînements au code', title: 'Statistiques', link: 'statistiques', possibleLink: 'statistiques', icon: 'statistiques', logged: false, engaged: false, code: false, locked: true },
      { group: 'Entraînements au code', title: 'NEPH', link: 'neph-infos', possibleLink: 'neph-infos', icon: '', logged: false, engaged: false, code: false, locked: true },
      // { group: 'Révisions du code', title: 'Commander mon livret de code', link: 'livret', possibleLink: 'synced-book', icon: 'livret-de-code', logged: false, engaged: false, code: false, locked: true },
      { group: 'Révisions du code', title: 'Cours de code', link: 'cours', possibleLink: 'cours', icon: 'cours', logged: false, engaged: false, code: false, locked: true },
      { group: 'Révisions du code', title: 'Recevoir le livre de code', link: 'livret', possibleLink: 'livret', icon: 'code', logged: false, engaged: false, code: false, locked: true },
      { group: 'Révisions du code', title: 'Fiches récap', link: 'fiches-recap', possibleLink: 'fiches-recap', icon: 'fiches', logged: false, engaged: false, code: false, locked: true },
      { group: 'Révisions du code', title: 'Nos replays de live de code', link: 'youtubeTiktok', possibleLink: 'youtubeTiktok', icon: 'video-default', logged: false, engaged: false, code: false, locked: true },
      { group: 'Examen du code', title: 'Terminer mon inscription', link: 'terminer-mon-inscription', possibleLink: 'terminer-mon-inscription', icon: 'resultat', logged: false, engaged: false, code: false, locked: true },
      { group: 'Examen du code', title: 'Passer l’examen plus vite', link: 'insExamen', possibleLink: 'insExamen', icon: 'speed', logged: false, engaged: false, code: false, locked: true },
    ];
    // ------------------

    this.checkPageLoadingTimeInterval = setInterval(() => {
      const now = Date.now();
      // 3 sec
      if ((now - this.pageStart) >= 3000) {
        this.longLoading = true;
        clearInterval(this.checkPageLoadingTimeInterval);
      }
    }, 200);

    if (!this.appInitService.done) {
      this.navigationService.timestamp = Date.now();
      this.navigationService.lastLink = this.router.url.substr(1);
      this.hasMadeInit = true;
    } else {
      this.hasMadeInit = false;
    }

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        if (!!this.navigationService.lastLink && this.navigationService.lastLink === this.router.url.substr(1)) {
          this.hasMadeInit = true;

          // Vérifier si les jours d'affilée ont déjà été initialisés
          this.hasInitializedDailyStreak = !!this.dailyStreakDays && this.dailyStreakDays.length > 0;

          if (this.appInitService.done) {
            this.pageLoaderSteps = ['initApp', 'initPage'];
          } else {
            this.cardsListDone = false;
            this.cerfaDone = false;
            this.paymentsDone = false;
            this.examenCodeDone = false;

             // Ne réinitialiser dailyStreakDays que s'il n'a pas déjà été initialisé
            if (!this.hasInitializedDailyStreak) {
              this.dailyStreakDays = [];
            }
            this.groupList = ['Entraînements au code', 'Révisions du code', 'Examen du code'];
            this.cardsList = [
              // COMBO : logged: FALSE + engaged: FALSE veut dire que c'est dispo dès guest
              // COMBO : logged: FALSE + engaged: TRUE veut dire que c'est dispo que si t'es engaged, pas si t'es logged
              // COMBO : logged: TRUE + engaged: TRUE veut dire que c'est dispo dès logged
              { group: 'Entraînements au code', title: 'Jours d’affilée', link: 'daily-streak', possibleLink: 'daily-streak', icon: '', logged: false, engaged: false, code: false, locked: true },
              { group: 'Entraînements au code', title: 'Séries simples', link: 'series/entrainements', possibleLink: 'series/entrainements', icon: 'serie-simple', logged: false, engaged: false, code: false, locked: true },
              { group: 'Entraînements au code', title: 'Examens blancs', link: 'series/examens', possibleLink: 'series/examens', icon: 'examen-blanc', logged: true, engaged: true, code: false, locked: true },
              { group: 'Entraînements au code', title: 'Révise ton code avec nous sur Tiktok', link: 'tiktok', possibleLink: 'tiktok', icon: 'video-default', logged: false, engaged: false, code: false, locked: false},
              { group: 'Entraînements au code', title: 'Séries thématiques', link: 'series/thematiques', possibleLink: 'series/thematiques', icon: 'thematiques', logged: false, engaged: true, code: true, locked: true},
              { group: 'Entraînements au code', title: 'Mes erreurs', link: 'series/erreurs/buffer', possibleLink: 'series/erreurs/buffer', icon: 'erreurs', logged: false, engaged: true, code: true, locked: true},
              { group: 'Entraînements au code', title: 'Statistiques', link: 'statistiques', possibleLink: 'statistiques', icon: 'statistiques', logged: false, engaged: false, code: false, locked: true },
              { group: 'Entraînements au code', title: 'NEPH', link: 'neph-infos', possibleLink: 'neph-infos', icon: '', logged: false, engaged: false, code: false, locked: true },
              // { group: 'Révisions du code', title: 'Commander mon livret de code', link: 'livret', possibleLink: 'synced-book', icon: 'livret-de-code', logged: false, engaged: false, code: false, locked: true },
              { group: 'Révisions du code', title: 'Cours de code', link: 'cours', possibleLink: 'cours', icon: 'cours', logged: false, engaged: false, code: false, locked: true },
              { group: 'Révisions du code', title: 'Recevoir le livre de code', link: 'livret', possibleLink: 'livret', icon: 'code', logged: false, engaged: false, code: false, locked: true },
              { group: 'Révisions du code', title: 'Fiches récap', link: 'fiches-recap', possibleLink: 'fiches-recap', icon: 'fiches', logged: false, engaged: false, code: false, locked: true },
              { group: 'Révisions du code', title: 'Nos replays de live de code', link: 'youtubeTiktok', possibleLink: 'youtubeTiktok', icon: 'video-default', logged: false, engaged: false, code: false, locked: true },
              { group: 'Examen du code', title: 'Terminer mon inscription', link: 'terminer-mon-inscription', possibleLink: 'terminer-mon-inscription', icon: 'resultat', logged: false, engaged: false, code: false, locked: true },
              { group: 'Examen du code', title: 'Passer l’examen plus vite', link: 'insExamen', possibleLink: 'insExamen', icon: 'speed', logged: false, engaged: false, code: false, locked: true },
            ];
            this.pageLoaderSteps = [
              'init0',
              'init1',
              'init2',
              'init3',
              'init4',
              'init5',
              'initPage',
            ];
          }
        }
      }
    });

    this.isCordova = this.platform.is('cordova');
    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student); // if student not ready return guest
    if (this.appInitService.done) {
      this.pageLoaderSteps = ['initApp', 'initPage'];
      this.pageLoaderService.setSteps(this.pageLoaderSteps.indexOf('initApp') + 1, this.pageLoaderSteps.length);
    }
    this.stepChangeSub = this.appInitService.onStepChange().subscribe(
      (state) => {
        if (state?.init && state?.stepDone) {
          this.pageLoaderService.setSteps(state.init + 1, this.pageLoaderSteps.length);
        }
        if (state?.initDone) {
          this.initServiceDone = true;
          this.initPage();
        }
      }
    );
  }

  getCustomRadioSelection(event) {
    console.log('getCustomRadioSelection', event);
  }

  ionViewWillLeave() {
    // this.cancel = true;
    this.examenCodeDone = false;
    this.cardsListDone = false;
    this.hasInitializedDailyStreak = false;

    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    if (!!this.stepChangeSub) {
      this.stepChangeSub.unsubscribe();
    }
  }

  dateToFormatFr(input?: any) {
    // console.log('-------------------');
    // console.log('dateToFormatFr input', input, typeof input);
    let output = this.dateToMoment(); // today by default
    if (!!input) {
      output = this.dateToMoment(input);
      if (typeof input === 'string') {
        output = this.dateToMoment(input);
        // if (!input.includes('+')) {
        //   console.log('input string', input);
        // }
        if (input.includes('/')) {
          console.error('input string', input);
        }
        // console.log('output', output);
        // console.log('-------------------');
      } else if (typeof input === 'number') {
        // timestamp
        output = this.dateToMoment(input);
        // console.log('input timestamp', input);
        // console.log('output', output);
        // console.log('-------------------');
      } else if (typeof input === 'object') {
        if (!moment.isMoment(input) && !!input.year && !!input.month && !!input.day) {
          // custom object
          const year = input.year;
          const month = (Number(input.month) < 10) ? '0' + Number(input.month) : Number(input.month);
          const day = (input.day < 10) ? '0' + input.day : input.day;
          const str = year + '-' + month + '-' + day + ' 00:00:00';
          output = this.dateToMoment(str);
          // console.log('input custom object', input, str);
          // console.log('output', output);
          // console.log('-------------------');
        } else {
          // date object
          output = this.dateToMoment(input);
          // console.log('input date', input, input.isValid());
          // console.log('output', output);
        }
      }
    }
    if (!output.isValid()) {
      console.log('-------------------');
      console.error('dateToFormatFr input', input, typeof input);
      console.error('dateToFormatFr output', output, output.toString(), output.isValid());
      console.error('-------------------');
    }
    // console.log('dateToFormatFr output', output, output.toString(), output.isValid());
    // console.log('-------------------');
    return output;
  }

  dateToMoment(input?: any) {
    const zone = "Europe/Paris";
    moment.tz.setDefault(zone);
    moment.locale('fr');
    if (!!input) {
      return moment(input).tz(zone);
    }
    return moment().tz(zone);
  }

  async initPage() {
    this.userLifeCycle = this.studentService.getUserLifeCycle(this.studentService.student);
    if (!this.displayErrorCode2023 && !this.displayMajCode2023 && !this.userLifeCycle.isUserGuest) {
      if (this.cdrVersionService.displayMajModal) {
          this.displayMajCode2023 = true;
      } else if (this.cdrVersionService.displayRestartModal) {
        this.displayRestartCode2023 = true;
      }
    }

    this.returningUserCase = false;
    this.fromLogin = await this.storageService.get('login');
    this.fromSignup = await this.storageService.get('signup');
    this.student = this.studentService.student;
    this.CPFSubscriptionsToConfirm = this.CPFSubscriptionsService.CPFSubscriptions.filter(elt => !!elt.video_displayable);

    this.userLifeCycle = this.studentService.getUserLifeCycle(this.student);
    this.configUser = await this.configUserService.getUserConfig(this.student);
    this.configApp = await this.configService.getAppConfig();
    if (!!this.configUser) {
      if (!!this.configUser.coursProgression) {
        this.coursProgression = this.configUser.coursProgression;
      }
    }

    // Ne construire le calendrier que si l'utilisateur n'est pas invité et qu'il n'a pas déjà été construit
    if (!this.student.isGuest() && (!this.dailyStreakDays || this.dailyStreakDays.length === 0)) {
      this.hasInitializedDailyStreak = true;
      await this.buildDailyStreakDays();
      this.dailyStreakLoading = false;
    }

    await this.fetchtCoursList();

    const callCenterElement = document.getElementById('call-center-phone');
    this.callCenterPhone = !!callCenterElement && !!callCenterElement.innerHTML ? callCenterElement.innerHTML : '';
    this.callCenterPhoneFormatted = !!callCenterElement && !!callCenterElement.innerHTML ? callCenterElement.innerHTML.replaceAll(' ', '') : '';

    await this.storageService.get(`${this.student.remoteId}-OfflineLastLink`).then(
      async link => {
        if (!!link && !!link.modalToOpenOnReload) {
          await this.storageService.remove(`${this.student.remoteId}-OfflineLastLink`);
          this.showEmbed(link.modalToOpenOnReload);
        }
      }
    );
  }

  async majCode2023(skip: boolean) {
    console.log('skip ? ', skip);
    if (!skip) {
      this.showSpiner = true;
      const resMaj = await this.cdrVersionService.handleMajCode2023();
      if (!resMaj) {
        this.showSpiner = false;
        this.displayMajCode2023 = false;
        this.majModalDisplayed = false;
        this.displayErrorCode2023 = true;
      } else {
        this.showSpiner = false;
        this.displayMajCode2023 = false;
        this.majModalDisplayed = false;
      }
    }
  }

  async restartCode2023() {
    this.displayRestartCode2023 = false;
    const resMaj = await this.cdrVersionService.handleMajCode2023();
    if (!resMaj) {
      this.displayErrorCode2023 = true;
    }
  }

  async initNext() {
    if (!this.userLifeCycle.isUserGuest && !this.userLifeCycle.isUserRegistered) {
      this.isEngaged = true;
    }

    this.seriesList = [];
    this.sessions = [];

    const resSeriesList = await this.seriesService.seriesContext.getSeriesList(this.student);
    if (!!resSeriesList && !!resSeriesList.errorCode && resSeriesList.errorCode === 'E301') {
      this.seriesListFailed = true;
    } else {
      this.seriesList = resSeriesList;
    }

    if (!this.seriesListFailed) {
      const resgetSessions = await this.sessionsService.sessionsContext.getSessions(this.student);
      if (!!resgetSessions && !!resgetSessions.errorCode && resgetSessions.errorCode === 'E301') {
        this.getSessionsFailed = true;
        this.userErrorHandlerService.addError({criticity: 30, service: 'fetchSessions', platform: 'both', data: resgetSessions.errorOriginal, errorCode: 'ssfss'});
      } else {
        this.sessions = resgetSessions;
      }
    }
    this.getPayments();

    await this.checkPromoCards();

    if (!!this.seriesList && this.seriesList.length > 0) {
      for (const serie of this.seriesList) {
        if (serie.type === 'Error') {
          let serieError;
          if (!!this.seriesService.errorSerie) {
            serieError = this.seriesService.errorSerie;
          } else {
            const resGetSerie = await this.seriesService.seriesContext.getSerie(serie.id, this.student, false);
            if (!!resGetSerie && !!resGetSerie.errorCode && resGetSerie.errorCode === 'E301') {
              this.getSerieFailed = true;
              // this.userErrorHandlerService.addError({criticity: 20, service: 'getSerie', platform: 'both', data: resGetSerie.errorOriginal, errorCode: 'ssfsr'});
            } else {
              this.seriesService.errorSerie = resGetSerie;
              serieError = this.seriesService.errorSerie;
            }
          }
          // console.log('serieError', JSON.stringify(serieError));
          if (!!serieError) {
            this.nbErreurs = (!!serieError.nbQuestions) ? serieError.nbQuestions : 0;
          } else {
            this.getSerieFailed = true;
          }
        }
      }
    } else {
      this.seriesListFailed = true;
    }
    this.nbErrorsDone = true;
    this.setCards();
    
    if (this.userLifeCycle.isUserCanDrive || (this.hasHours && !this.isPackPermis && !this.giftsWithHours)) {
      this.cardsList = this.cardsList.filter(elt => elt.title !== 'Recevoir le livre de code');
    }
    
    if (this.student.isGuest() || (!!this.student.initialWish && !!this.student.initialStatus)) {
      this.cardsList = this.cardsList.filter(elt => elt.title !== 'Terminer mon inscription');
    }

    // DATE TO CHANGE
    const today = this.dateToFormatFr();
    let btExamReservationShouldDisplay = true;
    let btConvoncationShouldDisplay = false;
    if (!!this.examenCode) {
      for (const exam of this.examenCode) {
        if (exam.type === 'code_exam') {
          // DATE TO CHANGE
          const dateExam = this.dateToFormatFr(exam.date);
          if (dateExam >= today && (exam.result === null || typeof exam.result === 'undefined') && (exam.cancelled_at === null || typeof exam.cancelled_at === 'undefined')) {
            btExamReservationShouldDisplay = false;
            btConvoncationShouldDisplay = true;
          }
        }
      }
    }
    if (!btExamReservationShouldDisplay) {
      this.cardsList = this.cardsList.filter(elt => elt.title !== 'Réserver mon examen');
    }
    if (!btConvoncationShouldDisplay) {
      this.cardsList = this.cardsList.filter(elt => elt.title !== 'Ma convocation');
    }
    
    if (!this.student.isGuest() && this.student.eligibleForRDVP ) {
      const examReservation = await this.studentService.fetchStudentExamReservation();
      this.examReservationWaitingCredits = !!examReservation && examReservation.attributes.status === 'en attente de crédits';
      if (this.examReservationWaitingCredits) {
        this.missingCredits = !((this.student?.creditStocks?.manualDriving?.quantity || 0) + (this.student?.creditStocks?.automaticDriving?.quantity || 0)) ? 2 : 2 - ((this.student?.creditStocks?.manualDriving?.quantity || 0) + (this.student?.creditStocks?.automaticDriving?.quantity || 0));
      }
    }
    
    if (!this.student.isGuest()) {
      this.CPFStartingSoon = this.CPFSubscriptionsService.CPFSubscriptions.filter((currentCPFSubscription) => {
        if (!currentCPFSubscription.session_start_date) return false;
        
        const today = new Date();
        const [CPFday, CPFmonth, CPFyear] = currentCPFSubscription.session_start_date.split('/');
        const currentCPFSubscriptionDate = new Date(CPFmonth + '/' + CPFday + '/' + CPFyear);

        return currentCPFSubscriptionDate > today;
      });

      this.CPFInEDOFErrorStatus = this.CPFSubscriptionsService.CPFSubscriptions.filter((currentCPFSubscription) => {
        if (!currentCPFSubscription.session_start_date) return false;
        
        const today = new Date();
        const [CPFday, CPFmonth, CPFyear] = currentCPFSubscription.session_start_date.split('/');
        const currentCPFSubscriptionDate = new Date(CPFmonth + '/' + CPFday + '/' + CPFyear);

        return currentCPFSubscriptionDate <= today && currentCPFSubscription.state === "accepted" && !!currentCPFSubscription.cpf_subscription_displayed_at;
      });
    }

    // PAGE LOAD EVENT
    if (!!this.navigationService.timestamp && !!this.navigationService.lastLink && !this.statsSent) {
      const statObj = { page: this.navigationService.lastLink, loadTime: Date.now() - this.navigationService.timestamp, withInit: this.hasMadeInit };
      if (this.statsService.isDebug) {
        console.log(statObj);
      }
      this.statsService.send({ name: 'page:view', payload: statObj });
      this.statsSent = true;
    }
    
    let documentsForIndex = [];
    const resFetchDocumentsForIndex: any = await this.studentDocumentsService.fetchDocumentsForindex(this.student).toPromise();
    if (!!resFetchDocumentsForIndex && !!resFetchDocumentsForIndex.errorCode && resFetchDocumentsForIndex.errorCode === 'E301') {
      documentsForIndex = [];
    } else {
      documentsForIndex = resFetchDocumentsForIndex;
    }
    
    let documents = [];
    const resFetchStudentsDocumentsByUserId: any = await this.studentDocumentsService.fetchStudentsDocumentsByUserId(this.student).toPromise();
    if (!!resFetchStudentsDocumentsByUserId && !!resFetchStudentsDocumentsByUserId.errorCode && resFetchStudentsDocumentsByUserId.errorCode === 'E301') {
      documents = [];
    } else {
      documents = resFetchStudentsDocumentsByUserId;
    }

    let drivingLicenseType = this.studentDocumentsService.documentTypeDrivingLicenseNEPH;
    documentsForIndex.forEach(elt => {
      if (typeof elt === 'object') {
        if (Object.keys(elt)[0] === this.studentDocumentsService.documentTypeDrivingLicenseNEPH) {
          drivingLicenseType = this.studentDocumentsService.documentTypeDrivingLicenseNEPH;
        }
        if (Object.keys(elt)[0] === this.studentDocumentsService.documentTypeDrivingLicense) {
          drivingLicenseType = this.studentDocumentsService.documentTypeDrivingLicense;
        }
      }
    });

    const registrationCertificate = documents.find(elt => elt.type === this.studentDocumentsService.documentTypeRegistrationCertificate);
    const drivingTheoryCertificate = documents.find(elt => elt.type === this.studentDocumentsService.documentTypeDrivingTheoryCertificate);
    const drivingLicense = documents.find(elt => elt.type === drivingLicenseType);
    
    if (!!this.studentPurshases.anyPurshases() && !registrationCertificate && !drivingTheoryCertificate && !drivingLicense) {
      this.displayNEPHInfosCard = true;
    }

    // console.log('initPage Time : ' + (Date.now() - this.startTime) / 1000);
    this.initFullDone = true;

    if (this.sessions.length > 0) {
      this.appRatingService.checkRating(this.student, this.sessions);
    }
    if (this.userLifeCycle.isUserGuest) {
      const item = {
        item_id: 'register',
        item_promo_type: 'regular',
        item_location_id: 'code_top',
        item_location_format: 'promo_card',
        item_promo_content: 'nouveaux_modes',
      };

      this.statsService.send({
        name: 'item:viewed', payload: {
          item: item
        }
      });
    } else if (this.userLifeCycle.isUserRegistered) {
      const item = {
        item_id: 'big_pack',
        item_promo_type: 'regular',
        item_location_id: 'code_top',
        item_location_format: 'promo_card',
        item_promo_content: 'choucoute',
      };

      this.statsService.send({
        name: 'item:viewed', payload: {
          item: item
        }
      });
    }
    console.log('check notification')
    if (this.platform.is('android') && this.platform.is('cordova') && this.displayModalPostRegistration === false) {
      this.checkConfig().then(
        check => {
          if (!check && !this.returningUserCase) {
            const bannerInfo = {itemLocationId: 'guest_opt_in'};
            if (!!this.fromLogin && this.fromLogin) {
              bannerInfo.itemLocationId = 'sign_in_opt_in';
            } else if (!!this.fromSignup && this.fromSignup) {
              bannerInfo.itemLocationId = 'sign_up_opt_in';
            } else if (!!this.student && !!this.student.remoteId && this.student.remoteId != 'GUEST') {
              bannerInfo.itemLocationId = 'logged_opt_in';
            }
            if (!this.showModalConsentPush) {
              console.log('modalConsentPush 1');
              this.openModalPack(bannerInfo, 'modalConsentPush', true);
              this.showModalConsentPush = true;
            }

            if (!!this.redirectCustom && this.redirectCustom === 'serie-discovery') {
              this.openLink('serie-discovery');
            }
          }
        }
      );
    }
    if (this.platform.is('ios') && this.platform.is('cordova') && this.displayModalPostRegistration === false) {
      const iOSATTStatus = await this.adjust.getAppTrackingAuthorizationStatus();

      if (!this.displayMajCode2023 && !this.displayRestartCode2023 && !this.displayErrorCode2023 && !this.configApp.iOSATTAnswered && !this.configApp.iOSATTSliderShown && iOSATTStatus === 0) {
        await this.configService.switchBoolean('iOSATTSliderShown');
        this.launchIOSATTScreen();
      } else if (this.CPFSubscriptionsToConfirm.length > 0) {
        this.showModalCPFSubscription();
      } else {
        this.checkConfig().then(
          check => {
            if (!check && !this.returningUserCase) {
              const bannerInfo = {itemLocationId: 'guest_opt_in'};
              if (!!this.fromLogin && this.fromLogin) {
                bannerInfo.itemLocationId = 'sign_in_opt_in';
              } else if (!!this.fromSignup && this.fromSignup) {
                bannerInfo.itemLocationId = 'sign_up_opt_in';
              } else if (!!this.student && !!this.student.remoteId && this.student.remoteId != 'GUEST') {
                bannerInfo.itemLocationId = 'logged_opt_in';
              }
              if (!this.showModalConsentPush) {
                console.log('modalConsentPush 2');
                this.openModalPack(bannerInfo, 'modalConsentPush', true);
                this.showModalConsentPush = true;
              }

              if (!!this.redirectCustom && this.redirectCustom === 'serie-discovery') {
                this.openLink('serie-discovery');
              }
            }
          }
        );
      }
    }
    if (!(this.platform.is('ios') && this.platform.is('cordova')) && this.displayModalPostRegistration === false && this.CPFSubscriptionsToConfirm.length > 0) {
      this.showModalCPFSubscription();
    }
  }

  // add entries in storage for debug
  async duplicateSeries() {
    if (this.addEntriesForDebug) {
      const question = await this.storageService.get('3877156406-Question-5650132440'); // s2 - q1
      console.log(question);
      for (let i = 0, len = 1600; i < len; i++) {
        await this.storageService.set('Question-duplicate' + i, question);
        console.log('q' + i + '/1600');
      }
      console.log('DONE DUPLICATE');
    }
  }

  crediterCompte(amount) {
    if (this.offers.length > 0) {
      let offerFound = null;
      if (!this.student?.driving_department || (!!this.student?.driving_department && !this.student?.driving_department?.pricing_zone_id)) {
        if (!!this.offers && this.offers.length > 0 && !this.fetchOffersFailed) {
          let offersFound = this.offers.filter(elt => elt.offer_type === 'hour');
          const minOffer = offersFound.reduce((prev, current) => (prev.amount < current.amount) ? prev : current);
          if (!!minOffer) {
            offersFound = minOffer;
          }
        }
      } else {
        if (!!this.studentCustomOffers && this.studentCustomOffers.length > 0 && !this.fetchStudentCustomOffersFailed) {
          offerFound = this.studentCustomOffers.find(elt => elt.offer_type === 'hour');
        }
      }
      // console.log(this.offers);
      // const offerFound = this.offers.find(elt => elt.offer_type === 'hour');
      if (!!offerFound?.id) {
        // force 1 hour link
        let device = 'desktop';
        if (this.platform.is('cordova')) {
          device = (this.platform.is('ios')) ? 'ios' : 'android';
        }
        const deviceAndPath = `${device}:mon-inscription-examen`;
        this.openLink('examRegalurization');
      } else {
        console.error('LeconsPage crediterCompte() : Offer not found !');
      }
    } else {
      console.error('LeconsPage crediterCompte() : Offers null!');
    }
  }

  getPayments() {
    this.studentPurshases = this.studentService.getStudentPurshases();
    const resGetOffers = this.studentPurshases.offers;
    if (!!resGetOffers && !!resGetOffers.errorCode && resGetOffers.errorCode === 'E301') {
      this.fetchOffersFailed = true;
    } else {
      this.offers = resGetOffers;
    }

    const resGetStudentCustomOffers = this.studentPurshases.studentCustomOffers;
    if (!!resGetStudentCustomOffers && !!resGetStudentCustomOffers.errorCode && resGetStudentCustomOffers.errorCode === 'E301') {
      this.fetchStudentCustomOffersFailed = true;
    } else {
      this.studentCustomOffers = resGetStudentCustomOffers;
    }
    this.gifts = this.studentPurshases.gifts;
    this.studentPurshases.linkOfferTopayment();
    this.studentPurshases.removeCouponsIfPresentInPayments();
    this.payments = this.studentPurshases.payments;
    this.coupons = this.studentPurshases.coupons;

    this.hasHours = this.studentPurshases.hasHours();
    this.isHourOnly = this.studentPurshases.isHourOnly();
    this.isPackCode = this.studentPurshases.isPackCode();
    this.isPackCodePremium = this.studentPurshases.isPackCodePremium();
    this.isPackPermis = this.studentPurshases.isPackPermis();
    this.giftsWithHours = this.gifts.filter(gg => !!gg.credits).length > 0;

    const tmp = this.gifts.concat(this.coupons);
    this.paymentsGiftsCoupons = tmp.concat(this.payments);

    if (!this.student?.driving_department || (!!this.student?.driving_department && !this.student?.driving_department?.pricing_zone_id)) {
      if (!!this.offers && this.offers.length > 0 && !this.fetchOffersFailed) {
        let offersFound = this.offers.filter(elt => elt.offer_type === 'big_pack');
        let minOffer = offersFound.reduce((prev, current) => (prev.amount < current.amount) ? prev : current);
        if (!!minOffer) {
          this.packPermisPrice = this.pricesFormater.transform(minOffer.amount) + '€';
          this.packPermisHours = minOffer.credits + 'h';
        }
        offersFound = [];
        minOffer = null;
        offersFound = this.offers.filter(elt => elt.offer_type === 'hour_pack' && elt.min_quantity === 30);
        minOffer = offersFound.reduce((prev, current) => (prev.amount < current.amount) ? prev : current);
        if (!!minOffer) {
          const unitPrice = (!!minOffer.min_quantity) ? (minOffer.amount / minOffer.min_quantity) : (minOffer.amout / minOffer.max_quantity);
          this.minHourPrice = this.pricesFormater.transform(unitPrice).replace(',', '.') + '€/h';
        }
      }
    } else {
      if (!!this.studentCustomOffers && this.studentCustomOffers.length > 0 && !this.fetchStudentCustomOffersFailed) {
        let offersFound = this.studentCustomOffers.find(elt => elt.offer_type === 'big_pack');
        const price = (!!offersFound && !!offersFound.amount) ? offersFound.amount : 749;
        const hours = (!!offersFound && !!offersFound.credits) ? offersFound.credits : 17;
        this.packPermisPrice = this.pricesFormater.transform(price) + '€';
        this.packPermisHours = hours + 'h';
        offersFound = [];
        offersFound = this.studentCustomOffers.find(elt => elt.offer_type === 'hour_pack' && elt.min_quantity === 30);
        const unitPrice = (!!offersFound.min_quantity && !!offersFound.amount) ? (offersFound.amount / offersFound.min_quantity) : (!!offersFound.amout && !!offersFound.max_quantity) ? (offersFound.amout / offersFound.max_quantity) : 'ERROR';
        this.minHourPrice = this.pricesFormater.transform(unitPrice).replace(',', '.') + '€/h';
      }
    }

    // if (!!this.offers && this.offers.length > 0 && !this.fetchOffersFailed) {
    //   for (const offer of this.offers) {
    //     if (offer.offer_type === 'hour_pack' && offer.min_quantity === 30) {
    //       const unitPrice = (!!offer.min_quantity) ? (offer.amount / offer.min_quantity) : (offer.amout / offer.max_quantity);
    //       this.minHourPrice = this.pricesFormater.transform(unitPrice).replace(',', '.') + '€/h';
    //     }
    //     if (offer.offer_type === 'big_pack') {
    //       this.packPermisPrice = this.pricesFormater.transform(offer.amount) + '€';
    //       this.packPermisHours = offer.credits + 'h';
    //     }
    //   }
    // }

    this.paymentsDone = true;
  }

  async checkPromoCards() {
    // DATE TO CHANGE
    const today: any = this.dateToFormatFr();
    if (this.userLifeCycle.isUserGuest || this.userLifeCycle.isUserRegistered || (!this.isPackPermis && !this.hasHours)) {
      for (const promoDates of this.promoDates) {
        if (!!promoDates) {
          // DATE TO CHANGE
          const start_at = this.dateToFormatFr(promoDates.start_at);
          // DATE TO CHANGE
          const end_at = this.dateToFormatFr(promoDates.end_at);
          // console.log(today, start_at, end_at);
          // console.log(today >= start_at, today <= end_at);
          if ((today >= start_at && today <= end_at) || promoDates.forceDemo) {
            this.promoCardTemplate = promoDates.template;
            if (this.promoCardTemplate === 'happygift') {
              if (!this.userLifeCycle.isUserGuest) {
                const userProperties = await this.studentService.fetchUserProperties();
                const cleanedPostalCode = (!!this.student.postalCode && typeof this.student.postalCode === 'string') ? this.student.postalCode : '';
                const postalCodeCoverage = [75, 77, 78, 91, 92, 93, 94, 95, 59, 67, 35, 44, 69, 38, 33, 31, 34];
                let isCovered = false;
                for (const code of postalCodeCoverage) {
                  if (cleanedPostalCode.startsWith(code.toString())) {
                    isCovered = true;
                  }
                }
                // console.log(userProperties.declared_registered_in_driving_school);
                if (isCovered && !!userProperties && !!userProperties.declared_registered_in_driving_school && !userProperties.declared_registered_in_driving_school) {
                  this.hasPromoCard = true;
                }
              } else {
                this.hasPromoCard = true;
              }
            } else {
              this.hasPromoCard = true;
            }
          }
        }
      }
    }
  }

  setCards() {
    this.groupList = ['Entraînements au code', 'Révisions du code', 'Examen du code'];
    if (this.showLastCours && this.coursProgression.length > 0 && !!this.iconIndexFromLastCours) {
      this.cardsList = [
        // COMBO : logged: FALSE + engaged: FALSE veut dire que c'est dispo dès guest
        // COMBO : logged: FALSE + engaged: TRUE veut dire que c'est dispo que si t'es engaged, pas si t'es logged
        // COMBO : logged: TRUE + engaged: TRUE veut dire que c'est dispo dès logged
        { group: 'Entraînements au code', title: 'Séries simples', link: 'series/entrainements', possibleLink: 'series/entrainements', icon: 'serie-simple', logged: false, engaged: false, code: false, locked: true },
        { group: 'Entraînements au code', title: 'Examens blancs', link: 'series/examens', possibleLink: 'series/examens', icon: 'examen-blanc', logged: true, engaged: true, code: false, locked: true },
        { group: 'Entraînements au code', title: 'Séries thématiques', link: 'series/thematiques', possibleLink: 'series/thematiques', icon: 'thematiques', logged: false, engaged: true, code: true, locked: true},
        { group: 'Entraînements au code', title: 'Révise ton code avec nous sur Tiktok', link: 'tiktok', possibleLink: 'tiktok', icon: 'video-default', logged: false, engaged: false, code: false, locked: false},
        { group: 'Entraînements au code', title: 'Mes erreurs', link: 'series/erreurs/buffer', possibleLink: 'series/erreurs/buffer', icon: 'erreurs', logged: false, engaged: true, code: true, locked: true},
        { group: 'Entraînements au code', title: 'Statistiques', link: 'statistiques', possibleLink: 'statistiques', icon: 'statistiques', logged: false, engaged: false, code: false, locked: true },
        { group: 'Entraînements au code', title: 'NEPH', link: 'neph-infos', possibleLink: 'neph-infos', icon: '', logged: false, engaged: false, code: false, locked: true },
        // { group: 'Révisions du code', title: 'Commander mon livret de code', link: 'livret', possibleLink: 'synced-book', icon: 'livret-de-code', logged: false, engaged: false, code: false, locked: true },
        { group: 'Révisions du code', title: 'Cours de code', link: 'cours', possibleLink: 'cours', icon: 'cours', logged: false, engaged: false, code: false, locked: true },
        { group: 'Révisions du code', title: 'Reprendre la lecture', subtitle: this.utils.ucfirst(this.coursProgression[this.index].lessonName), link: 'lastCours', possibleLink: 'lastCours', icon: 'reprendre-lecture', logged: false, engaged: false, code: false, locked: true },
        { group: 'Révisions du code', title: 'Recevoir le livre de code', link: 'livret', possibleLink: 'livret', icon: 'code', logged: false, engaged: false, code: false, locked: true },
        { group: 'Révisions du code', title: 'Fiches récap', link: 'fiches-recap', possibleLink: 'fiches-recap', icon: 'fiches', logged: false, engaged: false, code: false, locked: true },
        { group: 'Révisions du code', title: 'Nos replays de live de code', link: 'youtubeTiktok', possibleLink: 'youtubeTiktok', icon: 'video-default', logged: false, engaged: false, code: false, locked: true },
        { group: 'Examen du code', title: 'Terminer mon inscription', link: 'terminer-mon-inscription', possibleLink: 'terminer-mon-inscription', icon: 'resultat', logged: false, engaged: false, code: false, locked: true },
        { group: 'Examen du code', title: 'Passer l’examen plus vite', link: 'insExamen', possibleLink: 'insExamen', icon: 'speed', logged: false, engaged: false, code: false, locked: true },
      ];
    }
    for (const card of this.cardsList) {
      if (!!card) {
        card.locked = false;
        if ((card.logged || card.engaged) && this.userLifeCycle.isUserGuest) {
          card.locked = true;
        }
        if (!card.locked) {
          card.link = card.possibleLink;
        }
      }
    }
    this.cardsListDone = true;
    // alert(JSON.stringify(this.configUser));
    if (!!this.configUser) {
      if (!!this.configUser.showPostRegistration && this.configUser.showPostRegistration) {
        this.showModalPostRegistration();
      }
    }

    if (!this.userLifeCycle.isUserGuest) { // adieu code simone
      this.fetchCerfa();
    } else {
      // default add reserver mon examen
      const checkDoublons = this.cardsList.find((element) => {
        return (element.title === 'Réserver mon examen');
      });
      if (typeof checkDoublons === 'undefined') {
        this.cardsList.push({
          group: 'Examen du code',
          title: 'Réserver mon examen',
          icon: 'calendar',
          link: 'marketingRegister',
          logged: false,
          engaged: false,
          locked: false,
        });
      }
      this.examenCodeDone = true;
      // alert(2);
      // alert(JSON.stringify(this.configUser));
      if (!!this.configUser) {
        if (!!this.configUser.showPostRegistration && this.configUser.showPostRegistration) {
          this.showModalPostRegistration();
        }
      }
      this.pageLoaderService.setSteps(this.pageLoaderSteps.indexOf('initPage') + 1, this.pageLoaderSteps.length);
      setTimeout(() => {
        this.pageLoaderService.stepsDone();
      }, 300);
    }
  }

  async fetchtCoursList() {
    if (!!this.coursProgression && !!this.coursProgression.length && this.coursProgression.length > 0) {
      this.coursList = this.cdrLessonsService.cdrLessons;
      if (this.coursList.length > 0) {
        // console.log('processHistoriqueProgression');
        await this.processHistoriqueProgression(this.coursProgression.length - 1, true);
      } else {
        this.initNext();
      }
    } else {
      this.initNext();
    }
  }

  async processHistoriqueProgression(index: any, withInitNext = false) {
    // get index from theme name
    this.showLastCours = false;
    // console.log(this.coursList, this.coursProgression, this.isDesktop);
    if (!!this.coursList && !!this.coursProgression && !this.isDesktop) {
      if (this.coursList.length > 0 && this.coursProgression.length > 0) {
        let tmp = JSON.parse(JSON.stringify(this.coursList));
        tmp = this.groupByPipe.transform(tmp, this.coursGroupByValue);
        const lastTheme = this.coursProgression[index].theme.toLowerCase();
        const lastLesson = this.coursProgression[index].lessonName.toLowerCase();
        for (const item of tmp) {
          if (item.value[0].theme.toLowerCase() === lastTheme) {
            this.iconIndexFromLastCours = item.key;
          }
        }
        this.percent = 0;
        let counter = 0;
        const nbLessons = this.coursProgression[index].total;
        for (const item of this.coursProgression) {
          if (lastLesson === item.lessonName.toLowerCase()) {
            counter++;
          }
        }
        this.percent = Math.ceil((counter / nbLessons) * 100);
        if (this.percent === 100) {
          if (index > 0) {
            index--;
            await this.processHistoriqueProgression(index, withInitNext);
          } else {
            this.showLastCours = false;
            if (withInitNext) {
              this.initNext();
            }
          }
        } else {
          // console.log('showLastCours');
          this.index = index;
          this.showLastCours = true;
          if (withInitNext) {
            this.initNext();
          }
        }
      }
    } else {
      if (withInitNext) {
        this.initNext();
      }
    }
  }

  async buildDailyStreakDays() {
    // Réinitialiser le tableau pour éviter la duplication
    this.dailyStreakDays = [];

    const dailyStreaks = await this.gamificationService.fetchDailyStreaks(this.student.remoteId);
    
    if(!!dailyStreaks && Object.keys(dailyStreaks).length > 0) {
      // DATE TO CHANGE
      const today = this.dateToFormatFr();
      // DATE TO CHANGE
      const firstDay = this.dateToFormatFr();
      firstDay.date(firstDay.date() - 3);
  
      for (let i = 0; i < 5; i++) {
        // DATE TO CHANGE
        const tmpDay = this.dateToFormatFr(firstDay);
        tmpDay.date(tmpDay.date() + i);
  
        const year = tmpDay.year();
        const month = tmpDay.month() + 1 >= 10 ? tmpDay.month() + 1 : '0' + (tmpDay.month() + 1);
        const day = tmpDay.date() < 10 ? '0' + tmpDay.date() : tmpDay.date();
        const formattedDate = `${year}-${month}-${day}`;
        this.dailyStreakDays.push({
          day: tmpDay,
          dayString: tmpDay.day() === 0 ? this.days[6] : this.days[tmpDay.day() - 1],
          isStreak: dailyStreaks['dates'].includes(formattedDate),
          isActive: tmpDay.day() === today.day()
        })
      }
  
      this.currentDailyStreakText = dailyStreaks['daily_streak_current'] > 1 ? `${dailyStreaks['daily_streak_current']} jours` : `${dailyStreaks['daily_streak_current']} jour`;
      this.maxDailyStreakText = dailyStreaks['daily_streak_max'] > 1 ? `${dailyStreaks['daily_streak_max']} jours` : `${dailyStreaks['daily_streak_max']} jour`;
      this.dailyStreakDegradedText = dailyStreaks['daily_streak_current'] > 1 ? `${dailyStreaks['daily_streak_current']} Jours d'affilée` : `${dailyStreaks['daily_streak_current']} Jour d'affilée`;
    }
  }

  fetchCerfa() {
    const resGetCerfa = this.cerfaService.cerfa;
    if (!!resGetCerfa && !!resGetCerfa.errorCode && resGetCerfa.errorCode === 'E301') {
      this.loadStudentCerfaFailed = true;
      this.cerfaStatus = null;
    } else {
      this.cerfaStatus = (!!resGetCerfa) ? resGetCerfa : null;
    }
    if (!!this.cerfaStatus) {
      this.noCerfa = false; // j'ai recup un cerfa
      this.isCerfaValid = (!!this.cerfaStatus.confirmed_at && this.cerfaStatus.confirmed_at !== null) ? true : false; // cerfa valid ou pas en fonction de la date de confirmation
    } else {
      this.noCerfa = true; // j'ai pas recup de cerfa
    }
    this.cerfaDone = true; // check cerfa done

    if (!this.examenCodeDone) {
      this.fetchExamenCode();
    }
  }

  fetchExamenCode() {
    // console.log('Fetch Exam code', this.student);
    const resExamCode = this.examenCodeService.examens;
    if (!!resExamCode && !!resExamCode.errorCode && resExamCode.errorCode === 'E301') {
      // service failed
      this.fetchExamenCodeByUserIdFailed = true;
      this.examenCode = [];
      this.userErrorHandlerService.addError({criticity: 30, service: 'fetchExamenCodeByUserId', platform: 'both', data: resExamCode.errorOriginal, errorCode: 'ecsfecbui'});
    } else {
      this.examenCode = resExamCode;
    }

    // DATE TO CHANGE
    const today = this.dateToFormatFr();
    let isBtConvocation = false;
    let isBtResultatsExamens = false;

    let itemtitle = 'Réserver mon examen';
    let itemLink = 'dossier';
    let itemIcon = 'calendar';
    let hasSucceedExamCode = false;

    if (!this.userLifeCycle.isUserCanDrive && !this.userLifeCycle.isUserDrivingSuccess) {
      const skipNoCerfa = (this.userLifeCycle.isUserGuest) ? false : true;
      if (!this.isCerfaValid && !skipNoCerfa) {
        if (this.noCerfa) {
          // première modale
          itemLink = 'modaleDossier1';
        } else {
          // deuxième modale
          itemLink = 'modaleDossier2';
        }
        // NO CERFA = on renvoit vers dossier
        const checkDoublons = this.cardsList.find((element) => {
          return (element.title === itemtitle);
        });
        if (typeof checkDoublons === 'undefined') {
          this.cardsList.push({
            group: 'Examen du code',
            title: itemtitle,
            icon: itemIcon,
            link: itemLink,
            logged: false,
            engaged: false,
          });
        }
      } else {
        // CERFA OK : J'AI DES EXAMS PAST OU FUTUR
        if (!this.fetchExamenCodeByUserIdFailed && !!this.examenCode && this.examenCode.length > 0) {
          for (const exam of this.examenCode) {
            if (exam.type === 'code_exam') {
              // DATE TO CHANGE
              const dateExam = this.dateToFormatFr(exam.date);
              // CHECK PAST : si il a déjà fait un examen dans le passé + vérif si il l'a eu ou pas
              if (dateExam < today && (exam.result === 'success' || exam.result === 'failed') && (exam.cancelled_at === null || typeof exam.cancelled_at === 'undefined')) {
                itemtitle = 'Mes résultats d\'examen';
                itemLink = 'examen-code-examens';
                itemIcon = 'resultat_examen_code';
                isBtResultatsExamens = true;
                if (exam.result === 'success') {
                  hasSucceedExamCode = true;
                }
              }
            }
          }
          // si il n'a jamais passé son examen ou qu'il l'a failed
          if (hasSucceedExamCode) {
            if (isBtResultatsExamens) {
              // add card : "Mes résultats d'examen"
              const checkDoublons = this.cardsList.find((element) => {
                return (element.title === itemtitle);
              });
              if (typeof checkDoublons === 'undefined') {
                this.cardsList.push({
                  group: 'Examen du code',
                  title: itemtitle,
                  icon: itemIcon,
                  link: itemLink,
                  logged: false,
                  engaged: false,
                });
              }
            }
            // itemLink = 'exam-code-payment'; // avant
            itemLink = 'reservation-examen-code'; // maintenant on laisse le site faire tous ces checks
            itemtitle = 'Réserver mon examen';
            itemIcon = 'calendar';
            if (!!this.student?.creditStocks?.codeExam?.quantity && this.student.creditStocks.codeExam.quantity > 0) {
              // si t'as des sous tu réserves ton exam
              itemLink = 'reservation-examen-code'; // maintenant on laisse le site faire tous ces checks
            }
            // add card : "Réserver mon examen"
            const checkDoublons = this.cardsList.find((element) => {
              return (element.title === itemtitle);
            });
            if (typeof checkDoublons === 'undefined') {
              this.cardsList.push({
                group: 'Examen du code',
                title: itemtitle,
                icon: itemIcon,
                link: itemLink,
                logged: false,
                engaged: false,
              });
            }
          } else {
            // fail exam case = j'ai des resultats dans le passé mais aucun "success"
            if (isBtResultatsExamens) {
              // add card : "Mes résultats d'examen"
              const checkDoublons = this.cardsList.find((element) => {
                return (element.title === itemtitle);
              });
              if (typeof checkDoublons === 'undefined') {
                this.cardsList.push({
                  group: 'Examen du code',
                  title: itemtitle,
                  icon: itemIcon,
                  link: itemLink,
                  logged: false,
                  engaged: false,
                });
              }
            }

            // Check if futures convocations
            for (const exam of this.examenCode) {
              // console.log('EXAM FUTUR');
              if (exam.type === 'code_exam') {
                // DATE TO CHANGE
                const dateExam = this.dateToFormatFr(exam.date);
                // CHECK FUTUR : si il a des examens à venir
                 if (dateExam >= today && (exam.result === null || typeof exam.result === 'undefined') && (exam.cancelled_at === null || typeof exam.cancelled_at === 'undefined')) {
                  itemtitle = 'Ma convocation';
                  itemLink = 'examen-code-examens';
                  itemIcon = 'convocation-code';
                  isBtConvocation = true;
                  // console.log(exam);
                }
              }
            }
            if (isBtConvocation) {
              // add card : "Ma convocation"
              const checkDoublons = this.cardsList.find((element) => {
                return (element.title === itemtitle);
              });
              if (typeof checkDoublons === 'undefined') {
                this.cardsList.push({
                  group: 'Examen du code',
                  title: itemtitle,
                  icon: itemIcon,
                  link: itemLink,
                  logged: false,
                  engaged: false,
                });
              }
            } else {
              // SI NO EXAM FUTUR ADD RESERVER MON EXAMEN
              itemLink = 'reservation-examen-code'; // maintenant on laisse le site faire tous ces checks
              itemtitle = 'Réserver mon examen';
              itemIcon = 'calendar';
              // add card : "Réserver mon examen"
              const checkDoublons = this.cardsList.find((element) => {
                return (element.title === itemtitle);
              });
              if (typeof checkDoublons === 'undefined') {
                this.cardsList.push({
                  group: 'Examen du code',
                  title: itemtitle,
                  icon: itemIcon,
                  link: itemLink,
                  logged: false,
                  engaged: false,
                });
              }
              // Pas d'examens prévu dans le futur donc on peut réserver
              // Card : "Réserver mon examen"
              // par default tu payes
              // itemLink = 'exam-code-payment'; // avant
              itemLink = 'reservation-examen-code'; // maintenant on laisse le site faire tous ces checks
              itemtitle = 'Réserver mon examen';
              itemIcon = 'calendar';
              if (!!this.student?.creditStocks?.codeExam?.quantity && this.student.creditStocks.codeExam.quantity > 0) {
                // si t'as des sous tu réserves ton exam
                itemtitle = 'Ma convocation';
                itemIcon = 'convocation-code';
                itemLink = 'convocation';
              }
              // add card : "Réserver mon examen"
              const checkDoublons2 = this.cardsList.find((element) => {
                return (element.title === itemtitle);
              });
              if (typeof checkDoublons2 === 'undefined') {
                this.cardsList.push({
                  group: 'Examen du code',
                  title: itemtitle,
                  icon: itemIcon,
                  link: itemLink,
                  logged: false,
                  engaged: false,
                });
              }
            }
          }
        } else {
          // SI NO EXAM FUTUR ADD RESERVER MON EXAMEN
          itemLink = 'reservation-examen-code'; // maintenant on laisse le site faire tous ces checks
          itemtitle = 'Réserver mon examen';
          itemIcon = 'calendar';
          // add card : "Réserver mon examen"
          const checkDoublons = this.cardsList.find((element) => {
            return (element.title === itemtitle);
          });
          if (typeof checkDoublons === 'undefined') {
            this.cardsList.push({
              group: 'Examen du code',
              title: itemtitle,
              icon: itemIcon,
              link: itemLink,
              logged: false,
              engaged: false,
            });
          }
          // AUCUN EXAMEN EN STOCK = ADD CARD RESERVER EXAMEN
          // par default tu payes
          // itemLink = 'exam-code-payment'; // avant
          itemLink = 'reservation-examen-code'; // maintenant on laisse le site faire tous ces checks
          itemtitle = 'Réserver mon examen';
          itemIcon = 'calendar';
          if (!!this.student?.creditStocks?.codeExam?.quantity && this.student.creditStocks.codeExam.quantity > 0) {
            // si t'as des sous tu réserves ton exam
            itemtitle = 'Ma convocation';
            itemIcon = 'convocation-code';
            itemLink = 'convocation';
          }
          // add card : "Réserver mon examen"
          const checkDoublons2 = this.cardsList.find((element) => {
            return (element.title === itemtitle);
          });
          if (typeof checkDoublons2 === 'undefined') {
            this.cardsList.push({
              group: 'Examen du code',
              title: itemtitle,
              icon: itemIcon,
              link: itemLink,
              logged: false,
              engaged: false,
            });
          }
        }
      }
    } else {
      // USER AYANT EU LEUR EXAMEN CODE + COMMENCE LA CONDUITE (tout ça chez nous)
      if (this.isCerfaValid) { // SI CERFA OK
        if (!this.fetchExamenCodeByUserIdFailed && !!this.examenCode && this.examenCode.length > 0) { // SI J'AI DES EXAMS
          for (const exam of this.examenCode) {
            if (exam.type === 'code_exam') {
              // DATE TO CHANGE
              const dateExam = this.dateToFormatFr(exam.date);
              // CHECK PAST : si il a déjà fait un examen dans le passé + vérif si il l'a eu ou pas
              if (dateExam < today && exam.result === 'success') {
                itemtitle = 'Mes résultats d\'examen';
                itemLink = 'examen-code-examens';
                itemIcon = 'resultat_examen_code';
                isBtResultatsExamens = true;
              }
            }
          }
          if (isBtResultatsExamens) {
            // add card : "Mes résultats d'examen"
            const checkDoublons = this.cardsList.find((element) => {
              return (element.title === itemtitle);
            });
            if (typeof checkDoublons === 'undefined') {
              this.cardsList.push({
                group: 'Examen du code',
                title: itemtitle,
                icon: itemIcon,
                link: itemLink,
                logged: false,
                engaged: false,
              });
            }
          }
        }
        // CONDUITE ONLY (a eu le code ailleurs vient faire de la conduite chez nous)
        // ##############################################################
        // # Actuellement l'API theory_tests ne renvoit pas l'info !!!! #
        // ##############################################################
      }
    }
    if (this.fetchExamenCodeByUserIdFailed) {
      itemLink = 'reservation-examen-code'; // maintenant on laisse le site faire tous ces checks
      itemtitle = 'Réserver mon examen';
      itemIcon = 'calendar';
      if (!!this.student?.creditStocks?.codeExam?.quantity && this.student.creditStocks.codeExam.quantity > 0) {
        // si t'as des sous tu réserves ton exam
        itemLink = 'reservation-examen-code'; // maintenant on laisse le site faire tous ces checks
      }
      // add card : "Réserver mon examen"
      const checkDoublons = this.cardsList.find((element) => {
        return (element.title === itemtitle);
      });
      if (typeof checkDoublons === 'undefined') {
        this.cardsList.push({
          group: 'Examen du code',
          title: itemtitle,
          icon: itemIcon,
          link: itemLink,
          logged: false,
          engaged: false,
        });
      }
    }
    this.examenCodeDone = true;
    this.pageLoaderService.setSteps(this.pageLoaderSteps.indexOf('initPage') + 1, this.pageLoaderSteps.length);
    setTimeout(() => {
      this.pageLoaderService.stepsDone();
    }, 600);
    // console.log('examenCodeDone', this.cardsList);
  }

  hideModalEmbed() {
    this.showEmbedElt = false;
    this.embedSrc = null;
  }

  showEmbed(url) {
    if (!this.networkStatusService?.isOffline()) {
      this.embedSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.showEmbedElt = true;
    } else {
      this.navigationService.saveLinkToReload({modalToOpenOnReload: url});
    }
  }

  launchIOSATTScreen() {
    setTimeout(() => {
      this.showIOSATTScreen = true;
    }, 300);
  }

  closeIOSATTScreen(event) {
    if (event === 'close') {
      setTimeout(() => {
        this.showIOSATTScreen = false;

        if (this.CPFSubscriptionsToConfirm.length > 0) {
          this.showModalCPFSubscription();
        } else {
          this.checkConfig().then(
            check => {
              if (!check && !this.returningUserCase) {
                const bannerInfo = {itemLocationId: 'guest_opt_in'};
                if (!!this.fromLogin && this.fromLogin) {
                  bannerInfo.itemLocationId = 'sign_in_opt_in';
                } else if (!!this.fromSignup && this.fromSignup) {
                  bannerInfo.itemLocationId = 'sign_up_opt_in';
                } else if (!!this.student && !!this.student.remoteId && this.student.remoteId != 'GUEST') {
                  bannerInfo.itemLocationId = 'logged_opt_in';
                }
                if (!this.showModalConsentPush) {
                  console.log('modalConsentPush 3');
                  this.openModalPack(bannerInfo, 'modalConsentPush', true);
                  this.showModalConsentPush = true;
                }
              }
  
              if (!!this.redirectCustom && this.redirectCustom === 'serie-discovery') {
                this.openLink('serie-discovery');
              }
            }
          );
        }

      }, 300);
    }
  }

  callHideModalNoErrors(action?) {
    this.modalNoErrors.closeModal();
  }

  callHideModalSeriesFailed(action?) {
    this.modalSeriesFailed.closeModal();
  }

  gtmModalView(statObj: any) {
    this.statsService.send({ name: 'modal:view', payload: statObj });
  }

  gtmButtonClicked(statObj: any) {
    this.statsService.send({ name: 'button:click', payload: statObj });
  }

  showModalPostRegistration() {
    const pageName = '/modal/RegisterQuestionAutoecole';
    this.gtmModalView({'page': pageName});
    this.displayModalPostRegistration = true;
  }

  async hideModalPostRegistration(redirectCustom?: string) {
    if (!this.student) {
      this.student = await this.studentService.getProfil();
    }
    if (!this.configUser) {
      this.configUser = await this.configUserService.getUserConfig(this.student);
    }
    this.configUser.showPostRegistration = false;
    await this.configUserService.setUserConfig(this.student, this.configUser);
    this.displayModalPostRegistration = false;

    this.redirectCustom = redirectCustom;

    if (this.platform.is('android') && this.platform.is('cordova')) {
      this.checkConfig().then(
        check => {
          if (!check && !this.returningUserCase) {
            const bannerInfo = {itemLocationId: 'guest_opt_in'};
            if (!!this.fromLogin && this.fromLogin) {
              bannerInfo.itemLocationId = 'sign_in_opt_in';
            } else if (!!this.fromSignup && this.fromSignup) {
              bannerInfo.itemLocationId = 'sign_up_opt_in';
            } else if (!!this.student && !!this.student.remoteId && this.student.remoteId != 'GUEST') {
              bannerInfo.itemLocationId = 'logged_opt_in';
            }
            if (!this.showModalConsentPush) {
              console.log('modalConsentPush 4');
              this.openModalPack(bannerInfo, 'modalConsentPush', true);
              this.showModalConsentPush = true;
            }

            if (!!this.redirectCustom && this.redirectCustom === 'serie-discovery') {
              this.openLink('serie-discovery');
            }
          }
        }
      );
    }

    if (this.platform.is('ios') && this.platform.is('cordova')) {
      const iOSATTStatus = await this.adjust.getAppTrackingAuthorizationStatus();

      if (!this.displayMajCode2023 && !this.displayRestartCode2023 && !this.displayErrorCode2023 && !this.configApp.iOSATTAnswered && !this.configApp.iOSATTSliderShown && iOSATTStatus === 0) {
        await this.configService.switchBoolean('iOSATTSliderShown');
        this.launchIOSATTScreen();
      } else if (this.CPFSubscriptionsToConfirm.length > 0) {
        this.showModalCPFSubscription();
      } else {
        this.checkConfig().then(
          check => {
            if (!check && !this.returningUserCase) {
              const bannerInfo = {itemLocationId: 'guest_opt_in'};
              if (!!this.fromLogin && this.fromLogin) {
                bannerInfo.itemLocationId = 'sign_in_opt_in';
              } else if (!!this.fromSignup && this.fromSignup) {
                bannerInfo.itemLocationId = 'sign_up_opt_in';
              } else if (!!this.student && !!this.student.remoteId && this.student.remoteId != 'GUEST') {
                bannerInfo.itemLocationId = 'logged_opt_in';
              }
              if (!this.showModalConsentPush) {
                console.log('modalConsentPush 5');
                this.openModalPack(bannerInfo, 'modalConsentPush', true);
                this.showModalConsentPush = true;
              }
            }
          }
        );
      }
    } else {
      if (!!this.redirectCustom && this.redirectCustom === 'serie-discovery') {
        this.openLink('serie-discovery');
      }
    }
  }
  showModalObjectifCode() {
    const pageName = '/modal/RegisterQuestionMotivation';
    this.gtmModalView({'page': pageName});
    this.displayModalObjectifCode = true;
  }
  hideModalObjectifCode() {
    this.displayModalObjectifCode = false;
  }
  showModalHasAutoEcole() {
    const pageName = '/modal/RegisterEnAutoecole';
    this.gtmModalView({'page': pageName});
    this.displayModalHasAutoEcole = true;
  }
  hideModalHasAutoEcole() {
    this.displayModalHasAutoEcole = false;
  }
  showModalHasNotAutoEcole() {
    const pageName = '/modal/RegisterPasEnAutoecole';
    this.gtmModalView({'page': pageName});
    this.displayModalHasNotAutoEcole = true;
  }
  hideModalHasNotAutoEcole() {
    this.displayModalHasNotAutoEcole = false;
  }
  hideModalDossierExam1() {
    this.displayModalDossierExam1 = false;
  }
  hideModalDossierExam2() {
    this.displayModalDossierExam2 = false;
  }
  hideModalNoErrors() {
    this.displayModalNoErrors = false;
  }
  hideModalSeriesFailed() {
    this.displayModalSeriesFailed = false;
  }

  showModalCPFSubscription() {
    this.displayModalCPFSubscription = true;
    for (let item of this.CPFSubscriptionsToConfirm) {
      const statObj = {
        cpf_subscription_id: item.id,
        cpf_offer_id: item.id,
        cpf_offer_name: item.name,
        cpf_offer_type: item.offer_type,
        cpf_offer_price: (item.ttc_price / 100).toFixed(2),
        cpf_edof_id: item.offer_external_id,
        cpf_offer_credits: item.credits
      };
      this.statsService.send({ name: 'modal:display_cpf', payload: statObj })
    }
  }
  hideModalCPFSubscription() {
    const reducedCPFSubscriptionsIDs = this.CPFSubscriptionsToConfirm.reduce((acc, elt) => {
      acc.push(elt.id)
      return acc;
    }, [])

    this.CPFSubscriptionsService.updateExamReservationDisplayed(this.student, reducedCPFSubscriptionsIDs).subscribe(
      (res) => {
        if (!!res && !!res.error && !!res.status) {
          if (res.status === 400) { // error classic
            this.displayModalCPFSubscription = false;
          }
          if (res.status === 404 || res.status === 403) {
            this.displayModalCPFSubscription = false;
          }
        } else {
          for (let item of this.CPFSubscriptionsToConfirm) {
            const statObj = {
              cpf_subscription_id: item.id,
              cpf_offer_id: item.offer_id,
              cpf_offer_name: item.name,
              cpf_offer_type: item.offer_type,
              cpf_offer_price: (item.ttc_price / 100).toFixed(2),
              cpf_edof_id: item.offer_external_id,
              cpf_offer_credits: item.credits
            };
            this.statsService.send({ name: 'modal:start_cpf', payload: statObj })
          }
          this.displayModalCPFSubscription = false;
        }
      },
      (err) => {
        throw new Error('MonInscriptionExamenPage submitExamReservationForm: ' + JSON.stringify(err));
      }
    );
    this.showEmbed('https://www.youtube.com/embed/_zEQ0vwWJG4?autoplay=1');
  }
  callHideModalDailyStreak(action?) {
    this.modalDailyStreak.closeModal();
  }

  hideModalDailyStreak() {
    this.displayModalDailyStreak = false;
  }

  openModalDailyStreak() {
    this.displayModalDailyStreak = true;
  }

  callHideModalNEPHInfos(action?) {
    this.modalNEPHInfos.closeModal();
  }

  hideModalNEPHInfos() {
    this.displayModalNEPHInfos = false;
  }

  openModalNEPHInfos() {
    this.displayModalNEPHInfos = true;
  }

  callHideModalANTSInfos(action?) {
    this.modalANTSInfos.closeModal();
    this.embedSrcANTS = null;
  }

  hideModalANTSInfos() {
    this.displayModalANTSInfos = false;
    this.embedSrcANTS = null;
  }

  openModalANTSInfos() {
    this.embedSrcANTS = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/1874F8eT4sE");
    this.callHideModalNEPHInfos();
    this.displayModalANTSInfos = true;
  }

  goBackToModalNEPHInfos() {
    this.callHideModalANTSInfos();
    this.openModalNEPHInfos();
  }

  neverBeenRegisteredAE() {
    this.statsService.send({
      name: 'item:neph_card_click',
      payload: {
        neph_card_button_id: 'card_neph_code_page_never_been_registered_AE'
      }
    });
    this.openModalANTSInfos();
  }

  alreadyRegisteredAE() {
    this.statsService.send({
      name: 'item:neph_card_click',
      payload: {
        neph_card_button_id: 'card_neph_code_page_already_registered_AE'
      }
    });
    this.openLink('documents');
  }

  openLinkGouvNEPH() {
    this.statsService.send({
      name: 'item:neph_card_click',
      payload: {
        neph_card_button_id: 'card_neph_code_page_register_ANTS'
      }
    });
    const link = "https://permisdeconduire.ants.gouv.fr/demarches-en-ligne/inscription-examen-permis";
    this.openLink(link, {target: '_system', forceOutLink: true});
  }

  async sendInsAutoEcoleValue() {
    // console.log(this.insAutoEcole);
    if (!!this.insAutoEcole) {
      this.showModalObjectifCode();
    } else {
      alert('PostRegistration InsAutoEcole is null!');
    }
  }

  async sendObjectifCode() {
    if (!!this.objectifCode) {
      const res = await this.studentService.postRegistration({'registred_with_driving_school': (this.insAutoEcole === 'oui') ? 'true' : 'false', 'code_motivation': this.objectifCode});
      if (!!res && !!res.registred_with_driving_school) {
        if (this.insAutoEcole === 'oui') {
          this.showModalHasAutoEcole();
        } else if (this.insAutoEcole === 'non') {
          this.showModalHasNotAutoEcole();
        }
      }
    } else {
      alert('PostRegistration ObjectifCode is null!');
    }
  }

  async redirectToPermis() {
    this.returningUserCase = true;
    this.gtmButtonClicked({category: 'register', label: 'vers_pack_permis'});
    await this.hideModalPostRegistration();
    this.openLink('permis');
  }

  async redirectToCode(redirectCustom?: string) {
    this.gtmButtonClicked({category: 'register', label: 'vers_code'});
    await this.hideModalPostRegistration(redirectCustom);
  }

  triggerCardActionById(link) {
    // console.log(link);
    if (link === 'marketingRegular') {
      this.openModalPack({
        item_id: 'big_pack',
        item_promo_type: 'regular',
        item_location_id: 'marketingregular',
        item_location_format: 'modale',
        item_promo_content: 'reserved',
      }, 'marketingRegular');
    } else if (link === 'marketingRegister') {
      this.openModalPack(null, 'marketingRegister');
    } else if (link === 'lastCours') {
      if (this.coursProgression.length > 0 && !!this.coursProgression[this.index] && !!this.coursProgression[this.index].url) {
        this.openLink(this.coursProgression[this.index].url);
      } else {
        this.openLink('cours');
      }
    } else if (link === 'modaleDossier1') {
      this.displayModalDossierExam1 = true;
    } else if (link === 'modaleDossier2') {
      this.displayModalDossierExam2 = true;
    } else if (link === 'exam-code-payment') {
      const examOffer = this.offers.filter(elt => elt.offer_type === 'code_exam');
      if (examOffer.length > 0 && !!examOffer[0].id) {
        this.openLink('paiement', { paiementId: examOffer[0].id });
      } else {
        console.error('Réserver mon exam : offer not found!');
      }
    } else if ((link === 'series/erreurs/buffer' || link === 'series/examens' || link === 'series/thematiques') && !this.initFullDone) {
      return false;
    } else if ((link === 'series/erreurs/buffer' || link === 'series/examens' || link === 'series/thematiques') && this.userLifeCycle.isUserGuest && this.initFullDone) {
      this.openModalPack(null, 'modalSeriesGuest');
    } else if (link === 'series/erreurs/buffer' && this.nbErreurs === 0 && !this.userLifeCycle.isUserGuest) {
      if (this.userLifeCycle.isFrozen) {
        if (!this.navigationService.frozenWhitelistRoutes.includes(link)) {
          if (!!this.student.subStatus && this.student.subStatus.includes('payment_failed')) {
            link = 'impayes';
            this.openLink(link);
          }
        }
      } else {
        if (this.seriesListFailed || this.getSerieFailed) {
          this.displayModalSeriesFailed = true;
        } else {
          if (this.initFullDone) {
            this.displayModalNoErrors = true;
          } else {
            return false;
          }
        }
      }
    } else if (link === 'livret') {
      if (this.student.isGuest() || !this.studentPurshases.hasHours()) {
        this.openModalPack({
          item_id: 'big_pack',
          item_promo_type: 'regular',
          item_location_id: 'marketingregularlivretcdr',
          item_location_format: 'modale',
          item_promo_content: 'reserved',
        }, 'marketingRegularLivretCDR');
      } else {
        this.openLink(link);
      }
    } else if (link === 'youtube') {
      const tempUrl = 'https://www.youtube.com/embed/9eUzFmapSgM?autoplay=1';
      this.showEmbed(tempUrl);
    } else if (link === 'daily-streak') {
      this.openModalDailyStreak();
    } else if (link === 'neph-infos') {
      this.statsService.send({
        name: 'item:neph_card_click',
        payload: {
          neph_card_button_id: 'card_neph_code_page'
        }
      });
      this.openModalNEPHInfos();
    } else {
      if (typeof link === 'object') {
        if (link.link === 'modalSeriesGuest') {
          const item = {
            item_id: 'register',
            item_promo_type: 'regular',
            item_location_id: 'code_top',
            item_location_format: 'promo_card',
            item_promo_content: 'nouveaux_modes',
          };

          this.statsService.send({
            name: 'item:clicked', payload: {
              item: item
            }
          });
          this.openModalPack(null, 'modalSeriesGuest');
        } else {
          if (link.link === 'permis') {
            const item = {
              item_id: 'big_pack',
              item_promo_type: 'regular',
              item_location_id: 'code_top',
              item_location_format: 'promo_card',
              item_promo_content: 'choucoute',
            };

            this.statsService.send({
              name: 'item:clicked', payload: {
                item: item
              }
            });
          }
          this.openLink(link.link);
        }
      } else {
        this.openLink(link);
      }
    }
  }

  async checkConfig(): Promise<boolean> {
    const appConfig = await this.configService.getAppConfig();
    return (!!appConfig && !!appConfig.pushNotifConsent);
  }

  async openModalPack(bannerInfo?: any, type?: string, noClose = false, customClass = '') {
    // evs-global.scss : small-modal | medium-modal
    if (!type) {
      type = 'marketingRegular';
    }
    let props;
    if (!!bannerInfo) {
      props = {
        'type': type,
        bannerInfo: {
          item_id: bannerInfo.itemId,
          item_promo_type: bannerInfo.itemPromoType,
          item_location_id: bannerInfo.itemLocationId,
          item_location_format: bannerInfo.itemLocationFormat,
          item_promo_content: bannerInfo.itemPromoContent,
        }
      };
    } else {
      props = {
        'type': type,
        bannerInfo: null
      };
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        backdropDismiss: false,
        componentProps: props
      });
    } else {
      modal = await this.modalController.create({
        component: ModalMarketingComponent,
        cssClass: customClass,
        componentProps: props
      });
    }
    return await modal.present();
  }

  async openModalIframe(url: any, type?: string, noClose = true) {
    if (!type) {
      type = 'iframe';
    }
    let modal;
    if (noClose) {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        backdropDismiss: false,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          'type': type,
          'url': url,
        },
      });
    } else {
      modal = await this.modalController.create({
        component: ModalIframeComponent,
        cssClass: 'custom-modal-iframe',
        componentProps: {
          'type': type,
          'url': url,
        },
      });
    }
    return await modal.present();
  }

  closeModals() {
    const modals = document.getElementsByTagName('ion-modal');
    while (modals.length > 0) {
      modals[0].parentNode.removeChild(modals[0]);
    }
  }

  async checkStorageLock(link: string) {
    let storageLocked = false;
    if (this.platform.is('cordova')) {
      storageLocked = !(await this.storageService.checkEnougthSpace());
    }
    if (storageLocked) {
      for (const lockedFeature of this.lockedFeatures) {
        if (link.includes(lockedFeature)) {
          this.openModalPack(null, 'modalStorage1');
          return true;
        }
      }
    }
    return false;
  }

  async openLink(link, options = {}) {
    let storageLocked = false;
    let callbackUrl = null;

    if (this.platform.is('cordova')) {
      storageLocked = await this.checkStorageLock(link);
    }
    if (!storageLocked) {
      callbackUrl = await this.navigationService.open(link, options);
    }
    if (!!callbackUrl && callbackUrl !== '') {
      this.openModalIframe(callbackUrl);
    }
  }

}
